import moment from 'moment';

/** "Athens Services' bill for 09/01/26 – 10/31/26 is scheduled for October 2026." and why (LB-6009). */
export const describeScheduledBill = laterBill => {
  const vendor = laterBill.vendorName;
  const who = vendor ? "".concat(vendor).concat(/s$/i.test(vendor) ? "'" : "'s", " bill") : "".concat(laterBill.fileName || 'A bill');
  const period = laterBill.serviceStartDate && laterBill.serviceEndDate ? " for ".concat(moment(laterBill.serviceStartDate).format('MM/DD/YY'), " \u2013 ").concat(moment(laterBill.serviceEndDate).format('MM/DD/YY')) : '';
  const month = moment(laterBill.scheduledFor, 'YYYY-MM-DD').format('MMMM YYYY');
  return ["".concat(who).concat(period, " is scheduled for ").concat(month, "'s table."), laterBill.reason].filter(Boolean).join(' ');
};